import { init } from 'emailjs-com';

// Initialize EmailJS
const initEmailJS = () => {
  // Replace with your actual EmailJS user ID
  init("user_xxxxxxxxxxxx");
};

export default initEmailJS; 